import {OPERATORS} from "../views/vulnfeed/tokens";
const {parseOp} = require("../views/vulnfeed/utils");

export function parseGitlabFilters(data) {
    const filters = [];
    const search = [];
    data.forEach((e) => {
        if (typeof e === 'string') {
            search.push(e);
            return;
        }
        if (!e?.value) return;
        let field;
        let value;
        let op = parseOp(e.value);
        if (e.value.data == '""' || e.value.data == '' || e.value.data == '\'"') {
            e.value.data = '';
        }
        field = e.type;
        value = e.value.data;

        if (typeof value === 'string') value = value.replace(/\"/g, '');
        if ((op === 'in' || op === 'not_in') && Array.isArray(value) && value.includes('null')) {
            value = value.filter((x) => x !== 'null');
            filters.push({
                field,
                op: 'is_null',
            });
        }
        filters.push({
            field,
            op,
            value,
        });
    });
    return {filters, search: search.join('')};
}


const REVERSE_OPERATORS = Object.fromEntries(
    Object.entries(OPERATORS).map(([k, v]) => [v, k])
);

export function reconstructGitlabFilters(filters) {
    if (!filters || !filters.length) {
        return [];
    }

    const gitlabFilters = [];


    filters.forEach(filter => {
        let {field, op, value} = filter;

        let operatorSymbol = REVERSE_OPERATORS[op];
        if (!operatorSymbol) return null;

        if (op === 'is_null') {
            operatorSymbol = OPERATORS['=='];
            value = null;
        }

        const reconstructedValue = {
            operator: operatorSymbol,
            data: value || null
        };

        gitlabFilters.push({
            type: field,
            value: reconstructedValue
        });
    });

    return gitlabFilters;
}
